import { Observable } from 'rxjs';
import { Rpc } from '../rpc';
import { RpcObservableClient } from '../rpc-observable-client';
import { RpcOutbound } from '../rpc-outbound';
import {
    RpcObservablePerformanceError, RpcObservablePerformanceKey, RpcObservablePerformanceRequest, RpcObservablePerformanceResult
} from './rpc-observable-performance-model';

export class RpcObservablePerformanceClient
    extends RpcObservableClient<RpcObservablePerformanceRequest, RpcObservablePerformanceResult, RpcObservablePerformanceError>  {

    /**
     * Initializes a new instance of the RpcObservablePerformanceClient class.
     *
     * @param rpc the rpc object.
     */
    constructor(rpc: Rpc) {
        super(rpc, RpcObservablePerformanceKey.command, RpcObservablePerformanceKey.version);
    }

    /**
     * The Performance command.
     *
     * @param request the Rpc Performance data object.
     * @param outbound the Rpc outbound channel object.
     * @return Observable<RpcObservablePerformanceResult> the observable object.
     */
    public log(request: RpcObservablePerformanceRequest, outbound?: RpcOutbound): Observable<RpcObservablePerformanceResult> {
        return this.observableCall(request, outbound);
    }
}
